var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupportGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.58,247.44c-4.79,40.61-23.33,87.81-60.36,109.5C338.28,389.71,343,440.12,233.77,462a224,224,0,0,1-48.41,4.57,185.6,185.6,0,0,1-23.76-1.94C92.2,454.53,45.5,406.29,28.37,348.06,5.82,271.48,50.84,221.34,80.68,191.14S132.38,66.81,239.55,44.42a217.71,217.71,0,0,1,49.76-4.72c38.13.93,79.72,13.45,108.5,39.59,2.16,2,4.26,4,6.31,6.09C444.12,126.44,461.12,192.09,454.58,247.44Z",
    style: {
      fill: "#F68989"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.58,247.44c-4.79,40.61-23.33,87.81-60.36,109.5C338.28,389.71,343,440.12,233.77,462a224,224,0,0,1-48.41,4.57,185.6,185.6,0,0,1-23.76-1.94C92.2,454.53,45.5,406.29,28.37,348.06,5.82,271.48,50.84,221.34,80.68,191.14S132.38,66.81,239.55,44.42a217.71,217.71,0,0,1,49.76-4.72c38.13.93,79.72,13.45,108.5,39.59,2.16,2,4.26,4,6.31,6.09C444.12,126.44,461.12,192.09,454.58,247.44Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-13"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 423.01,
    y1: 422.6,
    x2: 423.01,
    y2: 309.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 413.86,
    y1: 422.6,
    x2: 413.86,
    y2: 366.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.87,328.25s-9.22-1.05-13-8.35-4.14-26.13,10.22-47,21.89-21.09,24.39-4.06,2.14,41.76-3.74,51.13S425.87,328.25,425.87,328.25Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.14,288.94c1.7-5.8,3.73-11,6.09-14.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422,327a268.53,268.53,0,0,1,6-34.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.36,364.88s-5.92-4.59-5.44-11.19,8.08-19.75,26.69-28.09,23.92-5.38,18.52,7.4-16,29.69-24,33.69S431.36,364.88,431.36,364.88Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.07,339.14c3.6-3.28,7.18-6,10.29-7.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.68,341.4a216.16,216.16,0,0,0-18.42,21s-4.77,6.42-6.18,19.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,403s-3.43-2.66-3.15-6.48,4.68-11.44,15.47-16.28,13.85-3.11,10.72,4.3-9.27,17.2-13.89,19.51S428,403,428,403Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.81,388.13a26,26,0,0,1,6-4.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.43,389.44a125.29,125.29,0,0,0-10.67,12.15s-2.77,3.72-3.59,11.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.65,349.62s5.91-4.59,5.44-11.19-8.08-19.75-26.7-28.09-23.91-5.38-18.51,7.4,16,29.69,24,33.69S414.65,349.62,414.65,349.62Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.94,323.88a45.39,45.39,0,0,0-10.3-7.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.33,326.14a216.64,216.64,0,0,1,18.41,21s4.77,6.42,6.19,19.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.74,400.59s6,.19,9-3.42,4.8-13.69-2.7-26S405.75,358,402.75,367,398,389.19,401,394.7,411.74,400.59,411.74,400.59Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.68,391.41c.09,1.23.15,2.46.18,3.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.08,366.41a140,140,0,0,1,4.34,22.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-13"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "24.89 327.7 163.3 327.7 163.3 45.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "310.18 327.7 171.77 327.7 171.77 45.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "228.26 327.7 366.67 327.7 366.67 45.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 338.43,
    y1: 111.53,
    x2: 290.05,
    y2: 164.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 311.59,
    y1: 152.89,
    x2: 298.17,
    y2: 167.72,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 204.96,
    y1: 97.49,
    x2: 178.83,
    y2: 126.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 212.02,
    y1: 90.46,
    x2: 229.68,
    y2: 70.95,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.65,
    y1: 269.17,
    x2: 140.7,
    y2: 287.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152,
    y1: 244.2,
    x2: 120.57,
    y2: 278.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-13"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 424.3,
    cy: 116.3,
    r: 50.1,
    transform: "translate(158.79 467.1) rotate(-68.21)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424.3,
    cy: 116.3,
    r: 43.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424.3,
    cy: 116.3,
    r: 2.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 424.3,
    y1: 119.29,
    x2: 424.3,
    y2: 133.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.31,
    y1: 116.3,
    x2: 385.65,
    y2: 116.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.77,237.22l-16.48-25.58a74.25,74.25,0,1,0-8.41,11.11Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.34,231l-16.49-25.58a74.19,74.19,0,1,0-8.4,11.11Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.64,177v-6.93L78,152.61c.86-1.29,1.67-2.55,2.44-3.76a22.23,22.23,0,0,0,1.88-3.7,10.68,10.68,0,0,0,.73-3.94,4.73,4.73,0,0,0-.82-3.05,2.75,2.75,0,0,0-2.23-1,3.37,3.37,0,0,0-2.47.88,4.59,4.59,0,0,0-1.2,2.35,15.08,15.08,0,0,0-.33,3.29V146H66.52v-2.52A19.89,19.89,0,0,1,67.87,136a11,11,0,0,1,4.29-5.23,13.9,13.9,0,0,1,7.69-1.91q6.41,0,9.66,3.32t3.26,9.25a15.29,15.29,0,0,1-.91,5.35,24.36,24.36,0,0,1-2.41,4.78c-1,1.55-2.06,3.16-3.2,4.85l-8.69,13H91.48V177Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.57,177V166.35H94.94v-7.22l12.4-29.66h11.39v29.6h4.4v7.28h-4.4V177Zm-7.17-18h7.17V139.28Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.78,177l14.56-47.57h5.17L131.89,177Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.85,177l10.34-40.11h-13v-7.46h22.55v6.75L162.43,177Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.88,207.48a6.18,6.18,0,0,1-3.33-.83,5.19,5.19,0,0,1-2-2.34,10.53,10.53,0,0,1-.82-3.52l2-.6a13.52,13.52,0,0,0,.55,2.75,4,4,0,0,0,1.25,1.94,3.48,3.48,0,0,0,2.34.72,3.63,3.63,0,0,0,2.55-.85,3.55,3.55,0,0,0,.91-2.71,5,5,0,0,0-.8-2.81,15.1,15.1,0,0,0-2.21-2.51L72,192.56a8,8,0,0,1-1.71-2.33,6.31,6.31,0,0,1-.54-2.63,5,5,0,0,1,1.52-3.92,5.82,5.82,0,0,1,4-1.37,7.75,7.75,0,0,1,2.35.34,4.35,4.35,0,0,1,1.8,1.08,5.25,5.25,0,0,1,1.17,1.93,12.28,12.28,0,0,1,.58,2.88l-2,.52a11.05,11.05,0,0,0-.5-2.66,3.31,3.31,0,0,0-1.19-1.68,3.72,3.72,0,0,0-2.23-.58,3.79,3.79,0,0,0-2.49.79,3,3,0,0,0-1,2.46,4.29,4.29,0,0,0,.38,1.82A6.36,6.36,0,0,0,73.6,191l4.34,4.1a15.61,15.61,0,0,1,2.53,3,6.93,6.93,0,0,1,1.06,3.77,6.13,6.13,0,0,1-.72,3.1,4.5,4.5,0,0,1-2,1.87A6.69,6.69,0,0,1,75.88,207.48Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6,207.18V182.56h8.9v1.79H86.94v9.24h5.35v1.7H86.94v10.15h6.63v1.74Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.73,207.18V182.56h5.56a7.5,7.5,0,0,1,3.63.74,4.27,4.27,0,0,1,1.9,2.16,8.75,8.75,0,0,1,.58,3.36,10.25,10.25,0,0,1-.31,2.58,4.93,4.93,0,0,1-1,2.07,3.52,3.52,0,0,1-2.07,1.12l3.77,12.59h-2.25l-3.61-12.1H99v12.1ZM99,193.38h3.13a4.6,4.6,0,0,0,2.4-.52,2.8,2.8,0,0,0,1.21-1.52,7.29,7.29,0,0,0,.37-2.52,5.94,5.94,0,0,0-.79-3.41c-.53-.75-1.57-1.12-3.13-1.12H99Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.35,207.18V182.56h2.31v24.62Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.38,207.18l-5.77-24.62h2.22L124.48,203l4.37-20.39H131l-5.56,24.62Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,207.18V182.56h2.31v24.62Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.36,207.48a6.2,6.2,0,0,1-3.84-1,5.23,5.23,0,0,1-1.87-2.78,13.49,13.49,0,0,1-.52-3.88V190a13.86,13.86,0,0,1,.53-4,5.06,5.06,0,0,1,1.9-2.7,6.45,6.45,0,0,1,3.8-1,6.22,6.22,0,0,1,3.48.85,4.75,4.75,0,0,1,1.81,2.42,11.48,11.48,0,0,1,.55,3.72v1.49H150v-1.42a13,13,0,0,0-.26-2.77,3,3,0,0,0-1.05-1.79,3.65,3.65,0,0,0-2.34-.64,3.9,3.9,0,0,0-2.48.68,3.43,3.43,0,0,0-1.12,1.93,13.07,13.07,0,0,0-.29,2.89v10.49a11.34,11.34,0,0,0,.35,3A3.23,3.23,0,0,0,144,205a4,4,0,0,0,2.34.61,3.59,3.59,0,0,0,2.34-.67,3.24,3.24,0,0,0,1.05-1.87,13.65,13.65,0,0,0,.26-2.81v-1.61h2.19v1.46a13.2,13.2,0,0,1-.51,3.83,4.78,4.78,0,0,1-1.76,2.59A5.93,5.93,0,0,1,146.36,207.48Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.78,207.18V182.56h8.91v1.79h-6.57v9.24h5.35v1.7h-5.35v10.15h6.63v1.74Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.68,320.17h53.57s-29,71.31-23.53,103.16H306.43S316.56,341.89,330.68,320.17Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.33,217.81s.53,9.65,18.5,15.28,36.21,0,46.4,8,9.92,20.38,6.43,26.55-9.12,12.33,7.51,19.57,6.7,28.43-.27,36.21-19,11.53-32.45,8.85-29.23-35.13-46.39-52.3-19.26-48.84-8.31-57.92S284.33,217.81,284.33,217.81Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.57,183.1s7.4-3.23,9.3,3,2.46,23.35,2.46,23.35l-4-.95s.95-19.36-3.42-22.4-7.78,3.8-7.78,3.8Z",
    style: {
      fill: "#a6a6a6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.5,391.38l25.28-13.52s-1.75-26.53-1.5-27.53,6.58-52.91,6.58-52.91l-17.34,51.41Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.26,270.76s25,13.62,28.36,15S340,304.51,340,315.86s-17,107.2-17,107.2H197.1s21.27-32.61,21.84-41.12-3.12-15.32-3.69-23.54,11.63-58.43,13.61-61,10.5-9.07,10.5-9.07L269.42,262l13.9-3.12Z",
    style: {
      fill: "#F68989",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 226.82,
    y1: 391.16,
    x2: 222.62,
    y2: 399.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.85,366.34s-6.24,4.25-3.12,6.52,4.54,7.09,4.54,7.09l-4,7.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.24,387c1.69.13,3.47.23,5.33.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.39,380s6.79,4.54,21.58,6.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.47,198.66a6.77,6.77,0,0,0-3.79,6.45c0,4.94,4,14.61,4,14.61l2.28-.75s-4.17-10.06-3.6-13.67a5.82,5.82,0,0,1,4-4.55l-.76-2.47Z",
    style: {
      fill: "#a6a6a6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.24,224.07c1,5-.71,9.51-3.75,10.1s-6.28-3-7.24-8,.71-9.52,3.75-10.1S225.28,219.08,226.24,224.07Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.47,222.46c1.89,6.38-.32,12.67-4.94,14s-9.9-2.69-11.8-9.07.32-12.67,4.94-14S233.58,216.08,235.47,222.46Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.6,257.24l4.49,14.6-14.76,18.6-2.46,14.37s-2.45,41-1.05,47.32,1.4,8.06,1.4,8.06,30.5-35.4,45.57-57.13S304.36,268,304.36,268L289.64,260l-7-32.6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.88 243.11 257.09 271.84 251.85 254.93 275.88 243.11",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,304l-.14.81s-2.45,41-1.05,47.32,1.4,8.06,1.4,8.06,30.5-35.4,45.57-57.13c1.18-1.7,2.28-3.35,3.33-4.95C270.24,304.57,251,304.68,240,304Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.61,167.73s-14.05,8.54-15.57,21.44,3.8,26.76,5.89,32.26,9.3,26.95,13.09,31.13,16.13,10.43,18.22,11.57,5.88.76,9.11-1.52,16.51-18.4,18.6-22.2,2.46-12.15,2.46-12.15-.38-16.7-1.13-27.51-.19-21.26-9.11-30.37S241.34,161.08,232.61,167.73Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.28,200.75c-.76-10.82-.19-21.26-9.11-30.37s-32.83-9.3-41.56-2.65c0,0-14.05,8.54-15.57,21.44-.88,7.5.55,15.3,2.3,21.62,3.23-2,14.13-8.68,26.36-17.25,14.61-10.25,19.36-26.19,19.36-26.19s1.7-.95,1.33,1.14-6.08,14.42-8.16,16.32l-2.09,1.89s1.71-.38,9.49,8.92,12.14,13.1,14.42,14.24a12.4,12.4,0,0,0,3.77.73C283.67,207.18,283.49,203.74,283.28,200.75Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.91,220.87c.24,1.39-.27,2.65-1.15,2.8s-1.78-.85-2-2.24.27-2.65,1.15-2.81S259.66,219.48,259.91,220.87Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.65,223.9c.25,1.4-.26,2.65-1.14,2.81s-1.79-.85-2-2.25.26-2.64,1.14-2.8S238.41,222.51,238.65,223.9Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.2,212.32s6.27-4.93,12-.95",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.49,215s-7.4-3.61-12.53,2.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.82,215.17s5.12,2.47,5.5,7.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.51,235.48s2.09,1.51,5.69.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,243.45a34.63,34.63,0,0,0,12.34-2.85c6.64-2.85,9.3-6.83,9.3-6.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.22,243.26a8.29,8.29,0,0,0,5.5,2.08c3.42,0,6.45-6.07,6.45-6.07S250.44,243.07,247.22,243.26Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 286.69,
    cy: 217.16,
    rx: 8.73,
    ry: 12.05,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 290.39,
    cy: 215.08,
    rx: 5.6,
    ry: 9.2,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.49,230s.06,19.72,5.18,21.43,19.17-1.71,19.17-1.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.05,249.64c0,1.52-1.87,2.75-4.18,2.75s-4.17-1.23-4.17-2.75,1.87-2.75,4.17-2.75S254.05,248.12,254.05,249.64Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.24,272.75s-6,10.49-10.21,41.69-1.42,37.43-1.42,37.43l-6,3.69s-12.47-1.42-8.22-30.91S236,290.33,236,290.33Z",
    style: {
      fill: "#F68989",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.24,262s-13.61,32.33-27.79,52.47S232,363.5,232,363.5s10.21-4.82,31.77-21,43.39-53.32,45.66-57,5.67-12.19,5.67-12.19Z",
    style: {
      fill: "#F68989",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.43,405.64A70.61,70.61,0,0,1,165,410.86c-6.38,2.61-7,2.15-4.93,4.35s12.76-1.74,15.66-2.9,8.41-2.9,8.41-2.9,6.67,3.77,10.73,4.93,9-.58,9-.58.29-4.64-3.19-7.25-11-8.7-13.63-8.41S175.43,405.64,175.43,405.64Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.69,398.68s-3.48-.87-5.8.87-4.93,7.25-5.22,8.7.29,2.32,2.61.29,6.38-4.93,6.38-4.93l3.48-1.16Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.68,396.07s-7-2.32-8.41-.29-6.38,13.63-4.93,14.5,3.48-.87,6.09-4.64,4.06-5.8,4.06-5.8l3.48-.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.11,398.67s-9.07-7.09-11.34-5.39-9.64,12.76-10.49,15,3.12,1.14,6.23-1.7,6.81-6,6.81-6l7.09,3.69Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.73,404.06s-11.91-.57-16.73-2.27-14.47-5.39-17.3-5.11-13.62,10.78-15.89,13.05-2,2.88.23,3.16,7.71-3.44,10.27-5.43a28,28,0,0,1,5.1-3.12,63.7,63.7,0,0,0,6.81,8.23c2.83,2.55,9.64,4.53,12.19,4.25a40,40,0,0,0,4.82-.85l9.65-.28Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.54,322.09s-10.49,12.19-9.92,16.45.85,8.5.85,8.5l-7.66,46.23s-6.52-3.12-6.52-.57v2.56L226,401.5l-.57,21.55,97.56.28s4.82-5.38,5.39-7.37,11.34-36.3,14.18-72.32,1.42-52.18,0-55-18.15-8.22-18.15-8.22",
    style: {
      fill: "#F68989",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.08,393s9.07,5.95,14.46,7.37",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,335.47,218,313a48.44,48.44,0,0,0,7.4-9.29c3-5.07,3-14.58,2.53-16.27s6.13-9.29,8-12,2.95-7.61.42-11.2-3.8,2.33-5.49,5.07-7.61,5.49-7.61,5.49L217,279.88s-10.35,9.08-11,10.35-1.9,5.28-1.9,5.28l.85,12.25-5.49,21.33Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.73,272.49s5.07-8,6.55-10.56,3.8-12.67,5.28-12,3,4,2.54,8.45-5.71,14.57-5.71,14.57Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.48,322.76l4.44-15L203,283.68l5.91-11.4,16.26-2.11s9.93,5.28,10.78,5.28,0,2.32-1.9,2.74-5.5-.63-5.5-.63l6.13,4s-.42,1.9-1.9,2.32a21.8,21.8,0,0,1-4.44.43s5.28,3.38,4,4a9.23,9.23,0,0,1-4,.84h-4l-3.17-.42-4.86,1.9s3.38,8.66,3.17,12.89-5.49,7-5.49,7",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.57,277.56s-3.38-2.75-5.28-2.75-13.51,2.11-13.51,2.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.36,284.32s-5.49-3-7.18-3-15,3.38-15,3.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.75,318.05,217.9,329.6s-7.64,41-8.39,44.51-6.25,12.76-9,15.52-6,2.25-13.51.25-14-8-13.77-15.77S200.75,318.05,200.75,318.05Z",
    style: {
      fill: "#F68989",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.13,
    y: 417.42,
    width: 4.98,
    height: 1.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.03,
    y: 417.42,
    width: 4.98,
    height: 1.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.93,
    y: 417.42,
    width: 4.98,
    height: 1.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.84,
    y: 417.42,
    width: 4.98,
    height: 1.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.74,
    y: 417.42,
    width: 4.98,
    height: 1.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.64,
    y: 417.42,
    width: 4.98,
    height: 1.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.54,
    y: 417.42,
    width: 4.98,
    height: 1.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.44,
    y: 417.42,
    width: 4.98,
    height: 1.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.34,
    y: 417.42,
    width: 4.98,
    height: 1.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.24,
    y: 417.42,
    width: 4.98,
    height: 1.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.15,
    y: 417.42,
    width: 4.98,
    height: 1.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.05,
    y: 417.42,
    width: 4.98,
    height: 1.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.95,
    y: 417.42,
    width: 4.98,
    height: 1.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.85,
    y: 417.42,
    width: 4.98,
    height: 1.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.75,
    y: 417.42,
    width: 4.98,
    height: 1.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.65,
    y: 417.42,
    width: 4.98,
    height: 1.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.27,
    y: 418.63,
    width: 123.39,
    height: 4.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.35,
    y: 418.63,
    width: 47.3,
    height: 4.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.77 380.62 45.76 380.62 26.28 277.46 123.29 277.46 142.77 380.62",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.82 378.01 45.71 378.01 27.22 280.07 121.32 280.07 139.82 378.01",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.7 370.21 51.73 370.21 37.98 297.4 107.95 297.4 121.7 370.21",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37.98,
    y1: 297.4,
    x2: 27.22,
    y2: 280.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.95,
    y1: 297.4,
    x2: 121.32,
    y2: 280.07,
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.7,
    y1: 370.21,
    x2: 139.82,
    y2: 378.01,
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.73,
    y1: 370.21,
    x2: 45.71,
    y2: 378.01,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.18 348.4 64.25 348.4 74.39 339.36 90.32 339.36 80.18 348.4",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.75,
    y: 417.54,
    width: 58.28,
    height: 5.79,
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.73 423.33 83.8 423.33 64.25 401.12 80.18 401.12 99.73 423.33",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.25,
    y: 348.77,
    width: 15.93,
    height: 52.12,
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.41,413.42a23.67,23.67,0,0,0,9.93,9.64",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.06,
    y1: 423.33,
    x2: 470.27,
    y2: 423.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportGroup);
export default __webpack_public_path__ + "static/media/support_group.80711acc0180aa32eb94e5488146f0f7.svg";
export { ForwardRef as ReactComponent };